(function () {
  function initCollection(section) {
    if (!section || section.dataset.pkCollectionInit === "true") return;
    section.dataset.pkCollectionInit = "true";

    var form = section.querySelector(".pk-viia__facet-form, .pk-collection__facet-form");
    var sort = section.querySelector("[data-pk-sort]");
    var filters = section.querySelector("[data-pk-filters]");
    var backdrop = section.querySelector(".pk-viia__filters-backdrop, .pk-collection__filters-backdrop");
    var debounceTimer;

    function buildUrl() {
      if (!form) return window.location.pathname;
      var params = new URLSearchParams(window.location.search);
      var formData = new FormData(form);
      var seenKeys = {};
      formData.forEach(function (_, key) {
        if (!seenKeys[key]) {
          params.delete(key);
          seenKeys[key] = true;
        }
      });
      formData.forEach(function (value, key) {
        if (value !== null && value !== "") params.append(key, value);
      });
      if (sort && sort.value) params.set("sort_by", sort.value);
      else params.delete("sort_by");
      var qs = params.toString();
      return window.location.pathname + (qs ? "?" + qs : "");
    }

    function submitFilters() {
      window.location.href = buildUrl();
    }

    function debouncedSubmit() {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(submitFilters, 450);
    }

    if (form) {
      form.addEventListener("change", submitFilters);
      form.addEventListener("input", function (event) {
        if (event.target && event.target.type === "number") debouncedSubmit();
      });
    }
    if (sort) sort.addEventListener("change", submitFilters);

    function openFilters() {
      if (!filters) return;
      filters.classList.add("is-open");
      if (backdrop) backdrop.hidden = false;
      document.body.style.overflow = "hidden";
    }

    function closeFilters() {
      if (!filters) return;
      filters.classList.remove("is-open");
      if (backdrop) backdrop.hidden = true;
      document.body.style.overflow = "";
    }

    section.querySelectorAll("[data-pk-filter-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        openFilters();
        btn.setAttribute("aria-expanded", "true");
      });
    });
    section.querySelectorAll("[data-pk-filter-close]").forEach(function (btn) {
      btn.addEventListener("click", closeFilters);
    });
  }

  function boot() {
    document.querySelectorAll("[data-pk-collection]").forEach(initCollection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-pk-collection]") || (event.target.matches && event.target.matches("[data-pk-collection]") ? event.target : null);
    if (root) {
      delete root.dataset.pkCollectionInit;
      initCollection(root);
    }
  });
})();
